import React, { useState } from "react";
import "./pages/css/App.css";
import "./pages/css/PopUp.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import frontendLogger from "./utils/frontendLogger.js";
import Login from "./pages/Login.js";
import Register from "./pages/Register.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import MainPage from "./pages/MainPage.js";
import TastingCreate from "./pages/TastingCreate.js";
import WhiskyCreate from "./pages/WhiskyCreate.js";
import DeleteWhiskys from "./pages/DeleteWhiskys.js";
import DeleteDistilleries from "./pages/DeleteDistilleries";
import DeleteTastings from "./pages/DeleteTastings.js";
import DistilleryDataCreate from "./pages/DistilleryDataCreate.js";
import AssignWhisky from "./pages/AssignWhisky.js";
import ForgotPassword from "./pages/ForgotPassword.js";
import ResetPassword from "./pages/ResetPassword.js";
import ManageUsers from "./pages/ManageUsers.js";

function App() {
  const [showVersionPopup, setShowVersionPopup] = useState(false);
  const [version, setVersion] = useState("");
  const [versionError, setVersionError] = useState("");
  const [versionLoading, setVersionLoading] = useState(false);

  const openVersionPopup = async () => {
    setShowVersionPopup(true);
    setVersionLoading(true);
    setVersionError("");

    try {
      if (process.env.REACT_APP_VERSION) {
        setVersion(process.env.REACT_APP_VERSION);
        return;
      }

      const response = await fetch(
        `${process.env.PUBLIC_URL}/VersionsInfo`,
        { cache: "no-store" },
      );
      if (!response.ok) {
        throw new Error(
          `Versionsdatei konnte nicht geladen werden (${response.status}).`,
        );
      }

      const loadedVersion = (await response.text()).trim();
      if (!/^(?:local-deployment|\d{4}\.\d{1,2}\.\d+)$/.test(loadedVersion)) {
        throw new Error(
          "Die Versionsdatei enthält keine gültige Version. Bitte frontend/build/VersionsInfo nach dem Build prüfen.",
        );
      }

      setVersion(loadedVersion);
    } catch (error) {
      frontendLogger.error("Error loading version information:", error);
      setVersionError(
        error instanceof Error
          ? error.message
          : "Versionsinformationen konnten nicht geladen werden.",
      );
    } finally {
      setVersionLoading(false);
    }
  };

  const handleLogoClick = (event) => {
    if (
      event.target instanceof Element &&
      event.target.closest(".whisky-image")
    ) {
      openVersionPopup();
    }
  };

  const handleLogoKeyDown = (event) => {
    if (showVersionPopup && event.key === "Escape") {
      setShowVersionPopup(false);
      return;
    }

    if (
      event.target instanceof HTMLImageElement &&
      event.target.classList.contains("whisky-image") &&
      (event.key === "Enter" || event.key === " ")
    ) {
      event.preventDefault();
      openVersionPopup();
    }
  };

  return (
    <Router>
      <div
        className="App"
        onClick={handleLogoClick}
        onKeyDown={handleLogoKeyDown}
      >
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/main" element={<MainPage />} />
          <Route path="/tasting-create" element={<TastingCreate />} />
          <Route path="/whisky-create" element={<WhiskyCreate />} />
          <Route path="/whisky-delete" element={<DeleteWhiskys />} />
          <Route path="/distillery-create" element={<DistilleryDataCreate />} />
          <Route path="/distillery-delete" element={<DeleteDistilleries />} />
          <Route path="/tasting-delete" element={<DeleteTastings />} />
          <Route path="/assign-whisky" element={<AssignWhisky />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="/manage-users" element={<ManageUsers />} />
        </Routes>
        {showVersionPopup && (
          <div
            className="popup-overlay"
            onClick={(event) => {
              if (event.target === event.currentTarget) {
                setShowVersionPopup(false);
              }
            }}
          >
            <div
              className="popup-content version-popup-content"
              role="dialog"
              aria-modal="true"
              aria-labelledby="version-popup-title"
            >
              <button
                type="button"
                className="popup-close"
                aria-label="Schließen"
                onClick={() => setShowVersionPopup(false)}
              >
                <i className="bi bi-x-lg" aria-hidden="true"></i>
              </button>
              <h2 id="version-popup-title">Versionsinformationen</h2>
              {versionLoading ? (
                <p>Version wird geladen...</p>
              ) : versionError ? (
                <p role="alert">{versionError}</p>
              ) : (
                <p>Version: {version}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;
